import { render, staticRenderFns } from "./DataTable.vue.js?vue&type=template&id=17907201&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=template&id=17907201&scoped=true"
import script from "./DataTable.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue.scss?vue&type=style&index=0&id=17907201&prod&lang=scss&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DataTable.vue?vue&type=style&index=0&id=17907201&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17907201",
  null
  
)

export default component.exports